(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('PatientPictureController', PatientPictureController);

    PatientPictureController.$inject = ['$scope', '$state', 'PatientPicture', 'PatientPictureSearch'];

    function PatientPictureController ($scope, $state, PatientPicture, PatientPictureSearch) {
        var vm = this;

        vm.patientPictures = [];
        vm.search = search;
        vm.loadAll = loadAll;

        function loadAll() {
            PatientPicture.query(function(result) {
                vm.patientPictures = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            PatientPictureSearch.query({query: vm.searchQuery}, function(result) {
                vm.patientPictures = result;
            });
        }    }
})();
